import { default as JGLoading } from '@justgiving/loading';
import styled from 'styled-components';

export function LoadingPage() {
  return (
    <LoadingScreenContainer>
      <JGLoading />
    </LoadingScreenContainer>
  );
}

const LoadingScreenContainer = styled.div`
  place-content: center;
  flex: 1;
`;
